const Common = {

    // BUTTON
    "add": "إنشاء",
    "submit": "حفظ",
    "apply": "تطبيق",
    "clear": "مسح",
    "cancel": "إلغاء",
    "ok": "موافق",
    "save_next": "حفظ وانتقال",
    "close": "إغلاق",

    // PAGE HEADER
    "filter": "تصفية",

    // TOOLTIP
    "download": "تحميل",
    "pdf": "PDF",
    "excel": "Excel",
    "edit": "تعديل",
    "delete": "حذف",
    "details": "التفاصيل",

    // TOAST
    "success_add": "تم الإنشاء بنجاح",
    "success_update": "تم التعديل بنجاح",
    "wrong": "حدث خطأ ما",

    // SWEET ALERT
    "confirm_text": "هل أنت متأكد أنك تريد الحذف؟",
    "delete_text": "تم الحذف بنجاح",

    // TABLE HEADER
    "table_no": "رقم",
    "table_action": "الإجراء",

    // PAGINATION
    "page_size": "حجم الصفحة",
    "previous": "السابق",
    "next": "التالي",

}

export default Common;